import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Light from './headers/light';
import LightAdmin from './headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Swal from 'sweetalert2';
import tw from "twin.macro";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import ScrollToTop from './ScrollToTop';
import { useTranslation } from 'react-i18next';
import Footerr from './footers/Footer';
import './ProductDetails.css';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings.js";

const HeaderRow = tw.div`flex justify-center items-center flex-col w-full`;
const Header = styled(SectionHeading)`
  width: 100%;
  text-align: center !important;
  font-size: 30px !important;
  font-weight: 600;
  font-family: 'Urbanist', sans-serif !important;
  line-height: 1.2;
  align-self: center;
  margin-left: 0;
  margin-bottom: 50px;
  margin-top: 50px;
`;

const ProductDetails = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const idSupplier = localStorage.getItem("id");

  // --- LOGIQUE CLIENT & FIDÉLITÉ ---
  const userStr = localStorage.getItem("user");
  const userData = userStr ? JSON.parse(userStr) : null;
  const customId = userData ? userData.custom_id : null;

  const [promoCode, setPromoCode] = useState("");
  const [appliedDiscountType, setAppliedDiscountType] = useState(null); // 'loyalty' | 'promo' | 'client_fidele_auto'
  const [discountAmount, setDiscountAmount] = useState(0); 
  const [loyaltyPoints, setLoyaltyPoints] = useState(0);

  const [isApplyingPromo, setIsApplyingPromo] = useState(false);
  const [appliedCode, setAppliedCode] = useState("");
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [role, setRole] = useState('');
  const [activeImage, setActiveImage] = useState('');
  const baseUrl = "https://rehabwmg.online/storage/";
  
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
  const [shampooProducts, setShampooProducts] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState("1");
  const [selectedVariants, setSelectedVariants] = useState([]);

  const [showCheckoutForm, setShowCheckoutForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [customer, setCustomer] = useState({ Name: "", Email: "", Phone: "", Address: "", City: "", notes: '' });
  const checkoutRef = useRef(null);

  const calculateDiscount = (oldPrice, newPrice) => {
    if (!oldPrice || !newPrice) return 0;
    const discount = ((oldPrice - newPrice) / oldPrice) * 100;
    return Math.round(discount);
  };

  const thumbnailStyle = (isActive) => ({
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    borderRadius: '8px',
    overflow: 'hidden',
    border: isActive ? '3px solid #4e7662' : '1px solid #eee',
    transition: 'all 0.2s ease-in-out',
    opacity: isActive ? 1 : 0.6,
    backgroundColor: '#fff'
  });

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  };

  const allowedProductIds = [115, 116, 117, 141];
  const currentProductId = product?.ProductID || product?.id; 
  const isUpsellAllowed = allowedProductIds.includes(Number(currentProductId));

  // Chargement des points
  useEffect(() => {
    if (customId) {
      axios.get(`https://rehabwmg.online/api/loyalty/${customId}`)
        .then(res => {
          const pointsActifs = res.data.points || res.data.points_actifs || 0;
          setLoyaltyPoints(pointsActifs);
          if (role === "client_fidele") {
            setPromoCode(customId);
          }
        })
        .catch(err => console.error("Erreur chargement points:", err));
    }
  }, [customId, role]);

  useEffect(() => {
    if (isUpsellAllowed) {
      axios.get('https://rehabwmg.online/api/champoing')
        .then((response) => {
          setShampooProducts(response.data);
          const initialId = product?.ProductID || product?.id || 115;
          setSelectedVariants([Number(initialId)]);
        })
        .catch((err) => console.error("Error fetching shampoo data:", err));
    } else {
      setShampooProducts([]); 
    }
  }, [product, isUpsellAllowed]);

  useEffect(() => {
    const userRole = localStorage.getItem('role');
    setRole(userRole);

    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`https://rehabwmg.online/api/products/${id}?lang=${i18n.language}`);
        if (!response.ok) throw new Error("Product not found");
        const data = await response.json();
        setProduct(data);
        setActiveImage(data.image);
      } catch (error) { console.error(error); }
    };
    fetchProductDetails();
  }, [id, i18n.language]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      try {
        const response = await fetch(`https://rehabwmg.online/api/same-category/${id}?lang=${i18n.language}`);
        const data = await response.json();
        setRelatedProducts(data.products || []);
      } catch (error) { console.error(error); }
    };
    if (id) fetchRelatedProducts();
  }, [id, i18n.language]);

  // CALCUL DU SOUS-TOTAL ET REMISES AUTOMATIQUES / MANUELLES
  const currentPrice = (role === 'supplier' || role === 'influenceur') ? product?.distributeur_price : product?.user_price;
  const subtotal = (currentPrice || 0) * quantity;

  useEffect(() => {
    if (appliedDiscountType === "loyalty") {
      const pointsDH = loyaltyPoints * 10;
      const autoDiscount = role === "client_fidele" ? subtotal * 0.10 : 0;
      setDiscountAmount(parseFloat((pointsDH + autoDiscount).toFixed(2)));
    } else if (appliedDiscountType === "promo") {
      const calculatedDiscount = subtotal * 0.10;
      setDiscountAmount(parseFloat(calculatedDiscount.toFixed(2)));
    } else if (role === "client_fidele") {
      const autoDiscount = subtotal * 0.10;
      setDiscountAmount(parseFloat(autoDiscount.toFixed(2)));
      setAppliedDiscountType("client_fidele_auto");
    }
  }, [quantity, role, subtotal, appliedDiscountType, loyaltyPoints]);

  const finalTotal = Math.max(0, Number((subtotal - discountAmount).toFixed(2)));

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - window.scrollY - top) / height) * 100;
    setZoomPos({ x, y });
  };

 const handleAddToCart = () => {
    if (!product || product.StockQuantity <= 0) {
      Swal.fire({ 
        title: t('Stock_epuise'), 
        icon: 'error',
        confirmButtonColor: '#4e7662' 
      });
      return false;
    }

    let cart = JSON.parse(localStorage.getItem('cart')) || [];
    const isSpecialRole = ['supplier', 'influenceur'].includes(role);
    
    const existingProductIndex = cart.findIndex(item => item.productID === product.ProductID);

    if (existingProductIndex !== -1) {
      cart[existingProductIndex].quantity += quantity;
      if (cart[existingProductIndex].quantity > product.StockQuantity) {
        cart[existingProductIndex].quantity = product.StockQuantity;
      }
    } else {
      cart.push({
        productID: product.ProductID,
        productName: product.Name,
        productImage: product.image,
        priceGain: product.user_price,
        productPrice: isSpecialRole ? product.distributeur_price : product.user_price,
        quantity: quantity
      });
    }

    localStorage.setItem('cart', JSON.stringify(cart));

    // 🟢 returnFocus: false empêche le navigateur de remonter la page à la fermeture de l'alerte
    Swal.fire({
      icon: 'success',
      title: i18n.language === 'ar' ? 'تم تحديث السلة!' : 'Panier mis à jour!',
      confirmButtonColor: '#4e7662',
      confirmButtonText: 'OK',
      returnFocus: false 
    }).then(() => {
      setTimeout(() => {
        checkoutRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 50);
    });

    return true;
  };

  const handleBuyNow = () => {
    const success = handleAddToCart();
    if (success) {
      setShowCheckoutForm(true);
      setTimeout(() => checkoutRef.current?.scrollIntoView({ behavior: 'smooth' }), 200);
    }
  };

  // APPLICATION DU CODE PROMO OU BOUTON FIDÉLITÉ
  const handleApplyPromo = async () => {
    const trimmedCode = promoCode.trim().toUpperCase();
    if (!trimmedCode) return;

    setIsApplyingPromo(true);

    try {
      const isFideliteCode = trimmedCode.startsWith("CF") || trimmedCode === (customId ? customId.toUpperCase() : "");

      if (isFideliteCode) {
        const loyaltyRes = await axios.get(`https://rehabwmg.online/api/loyalty/${trimmedCode}`);
        const pointsActifs = loyaltyRes.data.points || loyaltyRes.data.points_actifs || 0;
        const valeurDH = loyaltyRes.data.valeur_dh || (pointsActifs * 10);

        setLoyaltyPoints(pointsActifs);

        if (pointsActifs <= 0) {
          Swal.fire("Information", "Ce code de fidélité n'a aucun point actif (0 DH).", "info");
          if (role === "client_fidele") {
            setAppliedDiscountType("client_fidele_auto");
          } else {
            setDiscountAmount(0);
            setAppliedDiscountType(null);
            setAppliedCode("");
          }
          return;
        }

        // Active l'utilisation explicite des points au clic
        setAppliedDiscountType("loyalty");
        setAppliedCode(trimmedCode);

        Swal.fire({
          icon: "success",
          title: "Code fidélité appliqué !",
          text: `Remise de -${valeurDH}.00 DH (${pointsActifs} PTS)`
        });
        return;
      }

      const response = await axios.get(`https://rehabwmg.online/api/supplier-from-code/${trimmedCode}`);

      if (response.data) {
        setAppliedDiscountType("promo");
        setAppliedCode(trimmedCode);

        Swal.fire({
          icon: "success",
          title: "Code promo appliqué !",
          text: "Remise de -10% sur votre commande"
        });
      } else {
        Swal.fire({ icon: "error", title: "Code promo invalide" });
        if (role === "client_fidele") {
          setAppliedDiscountType("client_fidele_auto");
        } else {
          setDiscountAmount(0);
          setAppliedDiscountType(null);
          setAppliedCode("");
        }
      }

    } catch (error) {
      console.error("Erreur promo/loyalty:", error);
      Swal.fire({ icon: "error", title: "Code invalide ou introuvable" });
      if (role === "client_fidele") {
        setAppliedDiscountType("client_fidele_auto");
      } else {
        setDiscountAmount(0);
        setAppliedDiscountType(null);
        setAppliedCode("");
      }
    } finally {
      setIsApplyingPromo(false);
    }
  };

  // SOUMISSION DE LA COMMANDE
  const handleSubmitOrder = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!/^0[5-7][0-9]{8}$/.test(customer.Phone)) {
      Swal.fire("Erreur", "Numéro de téléphone invalide.", "error");
      setIsSubmitting(false);
      return;
    }

    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    let supplierId = idSupplier;
    
    const isPointsApplied = appliedDiscountType === 'loyalty';
    let paymentType = isPointsApplied ? 'point' : 'COD';
    let finalPromoCode = (isPointsApplied || appliedDiscountType === 'promo') ? promoCode.trim() : '';

    if (appliedCode && appliedDiscountType === 'promo') {
      try {
        const response = await axios.get(`https://rehabwmg.online/api/supplier-from-code/${appliedCode}`);
        supplierId = response.data.supplier_id || response.data.id;
      } catch (error) {
        console.error("Erreur récupération supplier ID");
      }
    }

    try {
      const custRes = await axios.post("https://rehabwmg.online/api/customers/create", { 
        ...customer, 
        SupplierID: supplierId 
      });

      const orderData = {
        product_ids: cart.map(i => i.productID),
        prices: cart.map(i => i.productPrice),
        quantities: cart.map(i => i.quantity),
        isOffer: cart.map(i => i.isOffer || false),
        customer_id: custRes.data.customer.CustomerID,
        supplierId: supplierId || idSupplier,
        notes: customer.notes,
        total: finalTotal,
        total_price: finalTotal,
        payment_type: paymentType,
        promo_code: finalPromoCode,
        use_points: isPointsApplied,
        discount_amount: discountAmount
      };

      await axios.post("https://rehabwmg.online/api/orders/create", orderData);

      Swal.fire(t("Commande_reussie"), "", "success");
      localStorage.removeItem("cart");
      navigate("/");
    } catch (error) { 
      Swal.fire("Erreur!", "Problème lors de la commande", "error"); 
    } finally { 
      setIsSubmitting(false); 
    }
  };

  if (!product) return <div className="p-5 text-center">{t('loading')}...</div>;

  const handleWhatsAppOrder = () => {
    const phoneNumber = "212661653922";
    const message = `Bonjour, je souhaite commander le produit : *${product.Name}*`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleOfferChange = (offerValue) => {
    setSelectedOffer(offerValue);
    const count = parseInt(offerValue, 10);
    const currentId = product?.ProductID || product?.id || 115;
    const fallbackId = shampooProducts[0]?.ProductID || currentId;

    const newVariants = Array.from({ length: count }, (_, i) => 
      i === 0 ? Number(currentId) : Number(fallbackId)
    );
    setSelectedVariants(newVariants);
  };

  const handleDropdownChange = (index, value) => {
    const updated = [...selectedVariants];
    updated[index] = Number(value);
    setSelectedVariants(updated);
  };

  const handleUpsellAddToCart = () => {
    let bundlePrice = 119;
    if (selectedOffer === "2") bundlePrice = 219;
    if (selectedOffer === "3") bundlePrice = 319;
    if (selectedOffer === "4") bundlePrice = 399;

    const originalProductPrice = 119;
    let cart = JSON.parse(localStorage.getItem('cart')) || [];

    selectedVariants.forEach((selectedId, index) => {
      const targetProduct = shampooProducts.find(p => p.ProductID === Number(selectedId));
      const pID = targetProduct ? targetProduct.ProductID : Number(selectedId);
      const pName = targetProduct ? targetProduct.Name : (product?.Name || "Shampoing");
      const pImage = targetProduct ? targetProduct.image : (product?.image || "");

      const existingProductIndex = cart.findIndex(item => item.productID === pID);

      if (existingProductIndex !== -1) {
        cart[existingProductIndex].quantity += 1;
        if (index === 0) cart[existingProductIndex].totalBundlePrice = bundlePrice;
      } else {
        const newItem = {
          productID: pID,
          productName: pName,
          productImage: pImage,
          priceGain: originalProductPrice,
          productPrice: originalProductPrice,
          quantity: 1,
          isOffer: 1
        };
        if (index === 0) newItem.totalBundlePrice = bundlePrice;
        cart.push(newItem);
      }
    });

    localStorage.setItem('cart', JSON.stringify(cart));
    Swal.fire({
      icon: 'success',
      title: i18n.language === 'ar' ? 'تم تحديث السلة!' : 'Panier mis à jour!',
      confirmButtonColor: '#4e7662',
      timer: 2500
    });
    return true;
  };

  const renderActionButtons = () => (
    <>
      <div className="row g-3 align-items-end mb-3">
        <div className="col-4 col-md-3">
          <label className="small fw-bold mb-2 d-block text-muted">{t('quantity')}</label>
          <input 
            type="number" 
            className="form-control text-center shadow-sm" 
            value={quantity} 
            min="1"
            onChange={(e) => setQuantity(Number(e.target.value))}
            style={{ height: '55px', borderRadius: '10px' }}
          />
        </div>

        <div className="col-8 col-md-9">
          <button 
            className="btn w-100 fw-bold text-white"
            onClick={handleBuyNow}
            style={{ backgroundColor: '#4e7662', height: '65px', borderRadius: '10px' }}
          >
            ⚡ {t('buy_now')}
          </button>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-6">
          <button 
            className="btn w-100 fw-bold"
            onClick={handleAddToCart}
            style={{ border: '2px solid #4e7662', backgroundColor:'transparent', color: '#4e7662', height: '65px', borderRadius: '10px' }}
          >
            🛒 {t('add_to_cart')}
          </button>
        </div>

        <div className="col-6">
          <button 
            className="btn w-100 fw-bold"
            onClick={() => navigate('/checkout')}
            style={{ backgroundColor:'transparent', height: '65px', color: '#4e7662', borderRadius: '10px' }}
          >
            💳 {t('Passer_a_la_caisse')}
          </button>
        </div>

        <div className="col-12">
          <button 
            className="btn w-100 fw-bold text-white"
            onClick={handleWhatsAppOrder}
            style={{ backgroundColor: '#25D366', height: '55px', borderRadius: '10px' }}
          >
            <i className="bi bi-whatsapp"></i> {i18n.language === 'ar' ? 'اطلب عبر واتساب' : 'Commander via WhatsApp'}
          </button>
        </div>
      </div>
    </>
  );

  const renderUpsellSection = () => {
    if (!isUpsellAllowed) return null;

    return (
      <div style={{ border: '1px solid #e5e7eb', borderRadius: '16px', padding: '24px', backgroundColor: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', direction: i18n.language === 'ar' ? 'rtl' : 'ltr' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
          <span style={{ fontSize: '18px' }}>🔥</span>
          <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
            {t("Offre_Speciale_Lot", "Offre Spéciale : Économisez en Lot !")}
          </h3>
        </div>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '12px', marginBottom: '20px' }}>
          {[
            { id: "1", qtyKey: "Qty_1_Shampoing", defaultQty: "1 Shampoing", price: "119 DH" },
            { id: "2", qtyKey: "Qty_2_Shampoings", defaultQty: "2 Shampoings", price: "219 DH" },
            { id: "3", qtyKey: "Qty_3_Shampoings", defaultQty: "3 Shampoings", price: "319 DH" },
            { id: "4", qtyKey: "Qty_4_Shampoings", defaultQty: "4 Shampoings", price: "399 DH" },
          ].map((offer) => {
            const isSelected = selectedOffer === offer.id;
            return (
              <button
                key={offer.id}
                type="button"
                onClick={() => handleOfferChange(offer.id)}
                style={{
                  padding: '12px',
                  borderRadius: '12px',
                  border: isSelected ? '2px solid #3d6e5b' : '1px solid #d1d5db',
                  backgroundColor: isSelected ? '#f4f7f6' : '#ffffff',
                  fontWeight: isSelected ? '700' : '500',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
              >
                <span style={{ fontSize: '12px', color: '#4b5563' }}>{t(offer.qtyKey, offer.defaultQty)}</span>
                <span style={{ fontSize: '15px', color: '#3d6e5b', fontWeight: '800', marginTop: '4px' }}>{offer.price}</span>
              </button>
            );
          })}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: selectedVariants.length > 1 ? 'repeat(2, minmax(0, 1fr))' : '1fr', gap: '12px', marginBottom: '20px' }}>
          {selectedVariants.map((selectedId, idx) => (
            <div key={idx} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', color: '#9ca3af' }}>
                {t("Shampoing_Numero", "Shampoing N°")}{idx + 1}
              </label>
              <select
                value={selectedId}
                onChange={(e) => handleDropdownChange(idx, e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '12px',
                  fontSize: '13px',
                  backgroundColor: '#f9fafb',
                  fontWeight: '600',
                  color: '#374151'
                }}
              >
                {shampooProducts.map((prod) => (
                  <option key={prod.ProductID} value={prod.ProductID}>{prod.Name}</option>
                ))}
              </select>
            </div>
          ))}
        </div>

        <button
          type="button"
          onClick={handleUpsellAddToCart}
          style={{ width: '100%', backgroundColor: '#3d6e5b', color: '#ffffff', fontWeight: '700', padding: '14px', borderRadius: '12px', border: 'none', fontSize: '13px', cursor: 'pointer' }}
        >
          🛍️ {t("Ajouter_Au_Panier_Upsell", "Ajouter au panier")}
        </button>
      </div>
    );
  };

  return (
    <AnimationRevealPage>
      <Helmet>
        <title>{product.TitleSEO || `${product.Name} | Rehab Bio Cosmetics`}</title>
        <meta name="description" content={product.MetaSEO || product.short_description?.replace(/<[^>]+>/g, '').slice(0, 160)} />
      </Helmet>
      
      <ScrollToTop />
      {role === 'admin' ? <LightAdmin /> : <Light />}

      <div className="container">
        <Header>{product.TitreSEO || product.Name}</Header>

        <div className="row">
          {/* LEFT: IMAGE */}
          <div className="col-md-6 order-1">
            <div 
              className="main-image-box mb-4 overflow-hidden position-relative"
              style={{ cursor: 'zoom-in', borderRadius: '12px' }}
              onMouseEnter={() => setIsZoomed(true)}
              onMouseLeave={() => setIsZoomed(false)}
              onMouseMove={handleMouseMove}
            >
              {product.old_price && (
                <motion.div
                  style={{
                    position: 'absolute',
                    top: '15px',
                    right: '15px',
                    backgroundColor: '#4e7662',
                    color: 'white',
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  -{calculateDiscount(product.old_price, currentPrice)}%
                </motion.div>
              )}

              <img 
                src={`${baseUrl}${activeImage}`} 
                alt={product.Name}
                className="img-fluid w-100"
                style={{
                  transformOrigin: `${zoomPos.x}% ${zoomPos.y}%`,
                  transform: isZoomed ? 'scale(1.8)' : 'scale(1)',
                  maxHeight: '600px',
                  objectFit: 'contain'
                }}
              />
            </div>

            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <div onClick={() => setActiveImage(product.image)} style={thumbnailStyle(activeImage === product.image)}>
                <img src={`${baseUrl}${product.image}`} style={imgStyle} alt="" />
              </div>
              {product.gallery?.map((item) => (
                <div key={item.id} onClick={() => setActiveImage(item.path)} style={thumbnailStyle(activeImage === item.path)}>
                  <img src={`${baseUrl}${item.path}`} style={imgStyle} alt="" />
                </div>
              ))}
            </div>

            <div className="d-block d-md-none mt-4 mobile-actions">
              {renderActionButtons()}
            </div>

            <div className="d-block d-md-none mt-3">
              {renderUpsellSection()}
            </div>
          </div>

          {/* RIGHT: INFO */}
          <div className="col-md-6 mt-4 mt-md-0 order-2">
            <p className="text-muted small">{product.Category}</p>
            <h2 className="fw-bold">{product.Name}</h2>

            <div className="mb-3">
              <span style={{ fontSize: '30px', color: '#4e7662', fontWeight: 800 }}>
                {currentPrice} {t('currency')}
              </span>
              {product.old_price && (
                <span className="text-muted text-decoration-line-through ms-2">
                  {product.old_price}
                </span>
              )}
            </div>

            {/* DESCRIPTION COURTE */}
            <div className="text-muted mb-4" dangerouslySetInnerHTML={{ __html: product.short_description }} />

            <div className="d-none d-md-block">
              {renderActionButtons()}
            </div>

            <div className="d-none d-md-block mt-4">
              {renderUpsellSection()}
            </div>
          </div>
        </div>

        {/* SECTION DESCRIPTION DÉTAILLÉE DU PRODUIT */}
        {product.Description && (
          <div className="row mt-5 pt-4 border-top">
            <div className="col-12">
              <h3 className="fw-bold mb-4" style={{ color: "#4e7662" }}>
                {i18n.language === 'ar' ? 'وصف المنتج' : 'Description du produit'}
              </h3>
              <div 
                className="product-description-content text-secondary lh-lg" 
                dangerouslySetInnerHTML={{ __html: product.Description }} 
              />
            </div>
          </div>
        )}
      </div>

      {/* CHECKOUT FORM INTEGRÉ */}
      <AnimatePresence>
        {showCheckoutForm && (
          <motion.div ref={checkoutRef} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mt-5 p-4 border-0 rounded-4 shadow-lg bg-white container">
            <h3 className="text-center mb-4 fw-bold" style={{ color: "#4e7662" }}>{t('Finaliser')}</h3>
            
            <form onSubmit={handleSubmitOrder} className="px-3 px-md-5">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="fw-bold mb-1 small">{t('Nom_Complet')}</label>
                  <input type="text" className="form-control p-3" required onChange={(e) => setCustomer({...customer, Name: e.target.value})} style={{ borderRadius: '10px' }} />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="fw-bold mb-1 small">{t('Numéro_de_Téléphone')}</label>
                  <input type="text" className="form-control p-3" required onChange={(e) => setCustomer({...customer, Phone: e.target.value})} style={{ borderRadius: '10px' }} />
                </div>
              </div>
              
              <div className="mb-4">
                <label className="fw-bold mb-1 small">{t('Adresse')}</label>
                <textarea className="form-control p-3" rows="2" required onChange={(e) => setCustomer({...customer, Address: e.target.value})} style={{ borderRadius: '10px' }}></textarea>
              </div>

              <div className="mb-4">
                <label className="fw-bold mb-1 small">{t('Ville')}</label>
                <textarea className="form-control p-3" rows="2" required onChange={(e) => setCustomer({...customer, City: e.target.value})} style={{ borderRadius: '10px' }}></textarea>
              </div>

              <div className="mb-3">
                <label className="fw-bold mb-1 small">{t('note')}</label>
                <textarea 
                  className="form-control p-3" 
                  rows="2" 
                  placeholder={t('note_texte')} 
                  onChange={(e) => setCustomer({...customer, notes: e.target.value})} 
                  style={{ borderRadius: '10px' }}
                ></textarea>
              </div>

              {/* SECTION CODE PROMO / FIDÉLITÉ */}
              <div className="mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8f9fa" }}>
                {role === "client_fidele" && (
                  <div className="alert alert-success p-2 small mb-3">
                    <i className="bi bi-gift me-2"></i>
                    <strong>Statut Client Fidèle :</strong> Remise de 10% appliquée !
                    <br />
                    <strong>Code Fidélité :</strong> {customId} ({loyaltyPoints} PTS / {loyaltyPoints * 10} DH)
                  </div>
                )}

                <label className="fw-bold mb-2 small">{t('Code_promo')}</label>
                <div className="d-flex gap-2">
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="EX: CFDALAL587 ou REHAB20"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                    style={{ borderRadius: '8px' }}
                  />
                  <button 
                    type="button" 
                    className="btn text-white px-4" 
                    style={{ backgroundColor: "#4e7662", borderRadius: "8px" }}
                    onClick={handleApplyPromo}
                    disabled={isApplyingPromo}
                  >
                    {isApplyingPromo ? "..." : t('Appliquer_code_promo')}
                  </button>
                </div>
              </div>

              {/* RÉSUMÉ DU TOTAL */}
              <div className="p-3 mb-4 rounded-3 border">
                <div className="d-flex justify-content-between mb-2">
                  <span>{t('Sous_total')}</span>
                  <span className="fw-bold">{subtotal.toFixed(2)} {t('currency')}</span>
                </div>
                
                {appliedDiscountType === "client_fidele_auto" && (
                  <div className="d-flex justify-content-between mb-2 text-success">
                    <span>Remise Client Fidèle (-10%)</span>
                    <span>-{discountAmount.toFixed(2)} {t('currency')}</span>
                  </div>
                )}

                {appliedDiscountType === "loyalty" && (
                  <>
                    {role === "client_fidele" && (
                      <div className="d-flex justify-content-between mb-2 text-success">
                        <span>Remise Client Fidèle (-10%)</span>
                        <span>-{(subtotal * 0.10).toFixed(2)} {t('currency')}</span>
                      </div>
                    )}
                    <div className="d-flex justify-content-between mb-2 text-success">
                      <span>Remise Points Fidélité ({loyaltyPoints} PTS)</span>
                      <span>-{(loyaltyPoints * 10).toFixed(2)} {t('currency')}</span>
                    </div>
                  </>
                )}

                {appliedDiscountType === "promo" && (
                  <div className="d-flex justify-content-between mb-2 text-primary">
                    <span>Remise Code Promo (-10%)</span>
                    <span>-{discountAmount.toFixed(2)} {t('currency')}</span>
                  </div>
                )}
                
                <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                  <span className="fw-bold fs-5">{t('Total')}</span>
                  <span className="fw-bold fs-4" style={{ color: "#4e7662" }}>
                    {finalTotal.toFixed(2)} {t('currency')}
                  </span>
                </div>
              </div>

              <button type="submit" disabled={isSubmitting} className="btn w-100 py-3 text-white fw-bold shadow" style={{ backgroundColor: '#4e7662', borderRadius: '10px', fontSize: '18px' }}>
                {isSubmitting ? t('Chargement') : t('Confirmer_commande')}
              </button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>

      {/* GALERIE DÉROULANTE */}
      {product.gallery && product.gallery.length > 0 && (
        <div className="pb-5 mt-5">
          <div className="container"> 
            <div className="position-relative gallery-outer-wrapper">
              
              <div 
                id="fullGallery"
                className="d-flex overflow-auto" 
                onScroll={(e) => {
                   const container = e.target;
                   const index = Math.round(container.scrollLeft / container.offsetWidth);
                   const dots = document.querySelectorAll('.gallery-dot');
                   dots.forEach((dot, i) => {
                     dot.style.opacity = i === index ? "1" : "0.3";
                     dot.style.transform = i === index ? "scale(1.2)" : "scale(1)";
                   });
                }}
                style={{ 
                  scrollSnapType: "x mandatory", 
                  WebkitOverflowScrolling: "touch",
                  display: "flex",
                  gap: "0px",
                  scrollbarWidth: 'none', 
                  msOverflowStyle: 'none'  
                }}
              >
                {product.gallery.map((item, index) => (
                  <div 
                    key={item.id || index}
                    className="w-100 flex-shrink-0"
                    style={{ 
                      scrollSnapAlign: "start", 
                      height: "auto"
                    }}
                  >
                    <img
                      src={`${baseUrl}${item.path}`}
                      alt={`Gallery ${index}`}
                      style={{ 
                        width: "100%", 
                        height: "auto", 
                        maxHeight: "500px",
                        objectFit: "contain",
                        backgroundColor: "#fff"
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* DOTS NAVIGATION */}
              <div className="d-flex justify-content-center gap-2 mt-3">
                {product.gallery.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      const container = document.getElementById('fullGallery');
                      container.scrollTo({ 
                        left: container.offsetWidth * index, 
                        behavior: 'smooth' 
                      });
                    }}
                    className="gallery-dot"
                    style={{
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      border: "none",
                      backgroundColor: "#4e7662",
                      opacity: index === 0 ? "1" : "0.3",
                      transition: "all 0.3s ease",
                      padding: 0
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* COMPACT REVIEWS CAROUSEL */}
      <div className="py-5">
        <div className="container">
          <h3 className="text-center fw-bold mb-4" style={{ color: "#2d3748", fontSize: "1.5rem" }}>
            {i18n.language === 'ar' ? 'آراء عملائنا' : 'Avis de nos clients'}
          </h3>

          <div className="position-relative">
            <div 
              id="reviewsScroll"
              className="d-flex gap-4 overflow-auto pb-4 px-2 custom-scrollbar" 
              onScroll={(e) => {
                const container = e.target;
                const index = Math.round(container.scrollLeft / 320);
                const dots = document.querySelectorAll('.review-dot');
                dots.forEach((dot, i) => {
                  dot.style.opacity = i === index ? "1" : "0.3";
                  dot.style.transform = i === index ? "scale(1.3)" : "scale(1)";
                });
              }}
              style={{ 
                scrollbarWidth: 'none', 
                msOverflowStyle: 'none',
                scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch'
              }}
            >
              {[
                { name: "ASMA Z.", text: "J’ai commencé à prendre ce complément... mes cheveux sont devenus plus forts.", product: "Complément alimentaire" },
                { name: "AMINA K.", text: "Cette crème est excellente... réduction des rides sur mon front. Bravo !", product: "Crème d’acide hyaluronique" },
                { name: "SARA L.", text: "Produit top, je recommande vivement pour les peaux sensibles.", product: "Lotion Micellaire" },
                { name: "Karima L.", text: "Produit top, je recommande vivement pour les peaux sensibles.", product: "Lotion Micellaire" },
                { name: "MOHAMED B.", text: "Livraison rapide et produit de très haute qualité.", product: "Pack Diabète" }
              ].map((rev, idx) => (
                <motion.div 
                  key={idx}
                  className="flex-shrink-0"
                  style={{ width: "300px", scrollSnapAlign: "center" }}
                >
                  <div className="small-testimonial-card shadow-sm" style={{ border: '1px solid #eee', borderRadius: '15px', padding: '20px', height: '100%' }}>
                    <div className="stars-mini mb-2" style={{ color: '#ffc107' }}>
                      <i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i><i className="bi bi-star-fill"></i>
                    </div>
                    <p className="small-quote" style={{ fontStyle: 'italic', fontSize: '14px' }}>"{rev.text}"</p>
                    <h6 className="small-reviewer mb-0 fw-bold">{rev.name}</h6>
                    <span className="small-product text-muted" style={{ fontSize: '12px' }}>/ {rev.product}</span>
                  </div>
                </motion.div>
              ))}
            </div>

            {/* REVIEWS DOTS INDICATOR */}
            <div className="d-flex justify-content-center gap-2 mt-2">
              {[0, 1, 2, 3, 4].map((i) => (
                <div 
                  key={i}
                  className="review-dot"
                  style={{ 
                    width: "8px", 
                    height: "8px", 
                    borderRadius: "50%", 
                    backgroundColor: "#4e7662", 
                    opacity: i === 0 ? "1" : "0.3",
                    transition: "all 0.3s ease"
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* INSTAGRAM REEL SECTION */}
      <div className="bg-white py-4">
        <div className="container text-center">
          <h3 className="fw-bold mb-4" style={{ color: "#4E7662" }}>
            {i18n.language === 'ar' ? 'شاهد المزيد' : 'Découvrez en vidéo'}
          </h3>
          
          <div className="reel-container mx-auto shadow-lg" style={{ maxWidth: "400px", borderRadius: "20px", overflow: "hidden" }}>
            <iframe
              src="https://www.instagram.com/reel/DGLZ6MIqXfY/embed"
              width="100%"
              height="650"
              frameBorder="0"
              scrolling="no"
              allowTransparency="true"
              allow="encrypted-media"
              title="Instagram Reel"
              style={{ border: "none", display: "block" }}
            ></iframe>
          </div>
          
          <div className="mt-4">
            <a 
              href="https://www.instagram.com/rehab_bio_cosmetics/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn px-4 fw-bold"
              style={{ backgroundColor: "#4E7662", color: "white", borderRadius: "10px" }}
            >
              <i className="bi bi-instagram me-2"></i>
              {i18n.language === 'ar' ? 'تابعنا على إنستغرام' : 'Suivez-nous sur Instagram'}
            </a>
          </div>
        </div>
      </div>

      <Footerr />
    </AnimationRevealPage>
  );
};

export default ProductDetails;